/**
 * Utility functions for handling image URLs
 */

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

/**
 * Get the full URL for an image
 * @param {string} imageUrl - The image URL (can be relative or absolute)
 * @returns {string} - Full absolute URL
 */
export const getImageUrl = (imageUrl) => {
  if (!imageUrl) {
    console.warn('getImageUrl: imageUrl vazia');
    return '';
  }
  
  // If already absolute URL (starts with http:// or https://)
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    console.log('getImageUrl: URL absoluta detectada:', imageUrl);
    return imageUrl;
  }
  
  // If relative URL, prepend API base URL
  if (imageUrl.startsWith('/')) {
    // Remove /api from API_URL if present
    const baseUrl = API_URL.replace('/api', '');
    const fullUrl = `${baseUrl}${imageUrl}`;
    console.log('getImageUrl: URL relativa convertida:', {
      original: imageUrl,
      baseUrl,
      result: fullUrl
    });
    return fullUrl;
  }
  
  // Fallback: treat as relative and prepend API base
  const baseUrl = API_URL.replace('/api', '');
  const fullUrl = `${baseUrl}/${imageUrl}`;
  console.log('getImageUrl: Fallback aplicado:', {
    original: imageUrl,
    baseUrl,
    result: fullUrl
  });
  return fullUrl;
};

/**
 * Get optimized image URL (for future image optimization)
 * @param {string} imageUrl - The image URL
 * @param {object} options - Options for image optimization
 * @returns {string} - Optimized image URL
 */
export const getOptimizedImageUrl = (imageUrl, options = {}) => {
  const { width, height, quality } = options;
  const fullUrl = getImageUrl(imageUrl);
  
  // For now, just return the full URL
  // In the future, we can add query params for image optimization
  // e.g., ?w=300&h=300&q=80
  
  return fullUrl;
};

/**
 * Preload an image
 * @param {string} imageUrl - The image URL to preload
 * @returns {Promise} - Resolves when image is loaded
 */
export const preloadImage = (imageUrl) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = getImageUrl(imageUrl);
  });
};

export default {
  getImageUrl,
  getOptimizedImageUrl,
  preloadImage,
};
